import { render, staticRenderFns } from "./OrganizationInfo.vue?vue&type=template&id=099a0af3"
import script from "./OrganizationInfo.vue?vue&type=script&lang=js"
export * from "./OrganizationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports